import React from 'react';
import { AccordionHeader } from 'core/controls/accordion/Accordion';

const OptionsAccordionHeader = ({
  className,
  header,
  count,
  alignButtonLeft,
  analyticsKey,
}) => {
  return (
    <AccordionHeader
      analyticsKey={analyticsKey}
      expandIcon="expand"
      collapseIcon="collapse"
      alignButtonLeft={alignButtonLeft}
      className={className}>
      <div className="accordion-title__simple-option-text">
        {header} ({count})
      </div>
    </AccordionHeader>
  );
};

export default OptionsAccordionHeader;
